export default {
  fetching: true,
  loading: true,

  permissionList: [],

  rolesResponse: {},
  allRolesResponse: [],
};
